import NavBar from './styled';

export default NavBar;
